import { Input } from "@/components/ui/input";
import { SearchSelect } from "@/components/SearchSelect";
import { COUNTRIES } from "@/lib/countries";
import { useLanguages } from "@/lib/languages";

export const ProfileFields = ({ value, setValue }) => {
  const langs = useLanguages();
  const set = (k) => (v) => setValue({ ...value, [k]: v });
  return (
    <div className="space-y-4">
      <div className="space-y-1.5">
        <label htmlFor="profile-name" className="text-sm font-semibold">Your name</label>
        <Input id="profile-name" data-testid="profile-name-input" value={value.name} maxLength={60} onChange={(e) => set("name")(e.target.value)}
          placeholder="What should we call you?" className="h-12 rounded-xl" />
      </div>
      <div className="grid sm:grid-cols-2 gap-4">
        <div className="space-y-1.5">
          <div className="text-sm font-semibold">Country</div>
          <SearchSelect testId="profile-country-select" value={value.country} onChange={set("country")} options={COUNTRIES}
            placeholder="Select your country" searchPlaceholder="Search countries…" />
        </div>
        <div className="space-y-1.5">
          <label htmlFor="profile-region" className="text-sm font-semibold">State / region <span className="font-normal text-muted-foreground">(optional)</span></label>
          <Input id="profile-region" data-testid="profile-region-input" value={value.region} maxLength={80} onChange={(e) => set("region")(e.target.value)}
            placeholder="e.g. Punjab, California" className="h-12 rounded-xl" />
        </div>
      </div>
      <div className="space-y-1.5">
        <div className="text-sm font-semibold">Your language</div>
        <SearchSelect testId="profile-language-select" value={value.language} onChange={set("language")} options={langs}
          placeholder="Choose a language" searchPlaceholder="Search 100+ languages…" />
        <p className="text-xs text-muted-foreground">Your rizz lines and the website will appear in this language.</p>
      </div>
    </div>
  );
};

export const profileValid = (v) => v.name.trim() && v.country && v.language;
